import { motion } from "framer-motion";
import { WHATSAPP_DISPLAY, buildWhatsAppUrl } from "../lib/api";

export default function WhatsAppFAB({ content = {} }) {
  const text = content.whatsapp_default_message || "Hola Pextlán, me gustaría más información de la ecocomunidad campestre.";
  return (
    <motion.a
      href={buildWhatsAppUrl(text)}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-fab"
      aria-label={`WhatsApp ${WHATSAPP_DISPLAY}`}
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1.2, type: "spring", stiffness: 200 }}
      className="wa-bounce fixed bottom-6 right-6 z-50 flex items-center gap-3 rounded-full bg-[#25D366] text-white pl-4 pr-5 py-3 shadow-[0_12px_30px_-10px_rgba(37,211,102,0.8)] hover:shadow-[0_18px_40px_-10px_rgba(37,211,102,0.9)] transition-shadow"
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="w-6 h-6 fill-current" aria-hidden="true">
        <path d="M20.52 3.48A11.86 11.86 0 0 0 12.06 0C5.5 0 .2 5.3.2 11.86c0 2.09.55 4.13 1.6 5.93L0 24l6.38-1.67a11.85 11.85 0 0 0 5.68 1.45h.01c6.56 0 11.86-5.3 11.86-11.86 0-3.17-1.23-6.15-3.41-8.44zM12.07 21.5h-.01a9.64 9.64 0 0 1-4.91-1.35l-.35-.21-3.78.99 1.01-3.69-.23-.38A9.64 9.64 0 0 1 2.4 11.86C2.4 6.5 6.7 2.2 12.07 2.2c2.57 0 4.98 1 6.8 2.82a9.56 9.56 0 0 1 2.82 6.84c0 5.36-4.3 9.66-9.62 9.66zm5.56-7.22c-.31-.15-1.83-.9-2.11-1-.28-.1-.49-.15-.7.16-.21.31-.8 1-.98 1.2-.18.21-.36.24-.67.08-.31-.16-1.3-.48-2.47-1.52-.91-.81-1.52-1.81-1.7-2.12-.18-.31-.02-.48.14-.64.14-.14.31-.37.47-.55.16-.18.21-.31.31-.52.1-.21.05-.39-.03-.55-.08-.16-.7-1.69-.96-2.32-.25-.61-.51-.52-.7-.53-.18-.01-.39-.01-.6-.01a1.15 1.15 0 0 0-.83.39c-.28.31-1.08 1.06-1.08 2.58s1.1 2.99 1.26 3.2c.16.21 2.18 3.33 5.28 4.67.74.32 1.32.51 1.77.66.74.24 1.41.2 1.95.12.59-.09 1.83-.75 2.09-1.47.26-.72.26-1.34.18-1.47-.08-.13-.28-.21-.59-.36z" />
      </svg>
      <span className="hidden sm:inline font-medium text-sm">Escríbenos</span>
    </motion.a>
  );
}
